module.exports = __webpack_public_path__ + "img/DI.f27a661d.png";